const SCREENSHOT_ITEM_SELECTOR = '[data-iaf-id="file-item"]';
const STATUS_ID = 'role-library-feedback-screenshot-status';

let activeObserver: MutationObserver | null = null;
let statusElement: HTMLDivElement | null = null;
let screenshotAttached = false;

const getOrCreateStatus = (document: Document): HTMLDivElement => {
  const existing = document.getElementById(STATUS_ID);
  if (existing instanceof HTMLDivElement) {
    return existing;
  }

  const status = document.createElement('div');
  status.id = STATUS_ID;
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  status.setAttribute('aria-atomic', 'true');
  status.style.cssText =
    'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;';
  document.body.appendChild(status);
  return status;
};

const syncScreenshotAnnouncement = (document: Document): void => {
  const isAttached = Array.from(document.querySelectorAll(SCREENSHOT_ITEM_SELECTOR)).some((item) =>
    item.textContent?.trim().toLowerCase().startsWith('screenshot')
  );

  if (isAttached && !screenshotAttached && statusElement) {
    statusElement.textContent = 'Screenshot captured and attached.';
  } else if (!isAttached && statusElement) {
    statusElement.textContent = '';
  }

  screenshotAttached = isAttached;
};

export const enforceFeedbackScreenshotAnnouncement = (container: HTMLElement): void => {
  stopEnforcingFeedbackScreenshotAnnouncement();

  const document = container.ownerDocument;
  statusElement = getOrCreateStatus(document);
  syncScreenshotAnnouncement(document);

  activeObserver = new MutationObserver(() => syncScreenshotAnnouncement(document));
  activeObserver.observe(document.body, { childList: true, subtree: true });
};

export const stopEnforcingFeedbackScreenshotAnnouncement = (): void => {
  activeObserver?.disconnect();
  activeObserver = null;
  statusElement?.remove();
  statusElement = null;
  screenshotAttached = false;
};
